"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var React = __importStar(require("react"));
var braintree_web_1 = __importDefault(require("braintree-web"));
var react_query_1 = require("react-query");
var update_paypal_1 = require("../../../mutations/update-paypal");
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
exports.default = (function () {
    var queryClient = (0, react_query_1.useQueryClient)();
    var callout = (0, callout_1.useCallout)().callout;
    var updatePaypal = (0, react_query_1.useMutation)("updateCreditCard", function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_paypal_1.UPDATE_PAYPAL, variables); }, {
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                    case 1:
                        _a.sent();
                        callout.success('Updated Payment!');
                        return [2 /*return*/];
                }
            });
        }); },
        onError: function (error) {
            console.log('error', error);
        },
    }).mutateAsync;
    var onClientInstanceReady = function (clientInstance) {
        braintree_web_1.default.paypalCheckout.create({
            client: clientInstance,
        }, function (paypalCheckoutErr, paypalCheckoutInstance) {
            var _this = this;
            paypalCheckoutInstance.loadPayPalSDK({
                vault: true,
                intent: 'tokenize',
            }, function () {
                window.paypal
                    .Buttons({
                    fundingSource: window.paypal.FUNDING.PAYPAL,
                    createBillingAgreement: function () {
                        return paypalCheckoutInstance.createPayment({
                            flow: 'vault',
                            intent: 'tokenize',
                        });
                    },
                    onApprove: function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var payload, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, paypalCheckoutInstance.tokenizePayment(data)];
                                case 1:
                                    payload = _a.sent();
                                    return [4 /*yield*/, updatePaypal({
                                            token: payload.nonce,
                                        })];
                                case 2:
                                    result = _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    onCancel: function (data) { },
                    onError: function (err) {
                        console.error('PayPal error', err);
                    },
                })
                    .render('#paypal-button')
                    .then(function () {
                    // Button rendered
                });
            });
        });
    };
    (0, react_1.useEffect)(function () {
        braintree_web_1.default.client
            .create({ authorization: window.accountApp.braintreeTokenizationKey })
            .then(function (clientInstance) {
            onClientInstanceReady(clientInstance);
        })
            .catch(function (reason) {
            console.error('Error creating Braintree client instance', reason);
        });
    }, []);
    return (React.createElement("div", { className: 'margin-bottom-8' },
        React.createElement("div", { className: 'text-center' },
            React.createElement("div", null,
                React.createElement("div", { id: 'paypal-button', style: { padding: '0px', marginLeft: '0px' } })))));
});
